import React from 'react';
import styled from 'styled-components';

const Footer = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: ${({ theme }) => theme.styles.headerBackground};
  border-top: 1px solid ${({ theme }) => theme.styles.headerBorder || theme.colors.borderMuted};
  padding: 10px 0;
  text-align: center;
  z-index: 999;
  backdrop-filter: blur(10px);
`;

const Text = styled.p`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: 0;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const HudFooter: React.FC = () => {
  return (
    <Footer>
      <Text>
        © 2025 NOVAWARFARE • TACTICAL INTERFACE v4.2.7 • COMMAND CLEARANCE: ALPHA
      </Text>
    </Footer>
  );
};

export default HudFooter; 
